declare const __APP_VERSION__: string;
declare const __GIT_SHA__: string;
declare const __BUILT_AT__: number;

/** This bundle's identity. Matches the `version.json` emitted next to it. */
export const BUILD_INFO = {
  version: __APP_VERSION__,
  sha: __GIT_SHA__,
  builtAt: __BUILT_AT__,
} as const;
